import { registerComponent, Component, DetailEvent } from "aframe";
import { SetAnimationEventDetail, AnimationMap, AnimationDefinition } from "../avatar";


registerComponent("animation-filter", {
	schema : {
		mirror : { type : "boolean", default : false },
		filter : { type : "string" },
		level : { type : "int", default : 0 }
	},
	init(this : Component & { data : { mirror : boolean, filter : string } })
	{
		const hook = (event : DetailEvent<SetAnimationEventDetail>) =>
		{
			const detail = event.detail, data = this.data, newAnims : AnimationMap = {};
			detail.level += data.level;
			for(let key in detail.animations)
			{
				let srcAnim = detail.animations[key];
				if(typeof srcAnim === "string")
					srcAnim = { clips : [ srcAnim ]} as AnimationDefinition;
				else if(Array.isArray(srcAnim))
					srcAnim = { clips : srcAnim } as AnimationDefinition;
				newAnims[key] = {
					clips : data.mirror ? srcAnim.clips.map( x => "~" + x ) : srcAnim.clips,
					filter : (data.filter && srcAnim.filter) ? (data.filter + srcAnim.filter) : srcAnim.filter
				};
			}
			detail.animations = newAnims;
		};
		this.el.addEventListener("set-animation", hook as EventListener);
	}
});